import { isNil, omitBy, isEmpty, isUndefined,find, toUpper } from 'lodash';
import statesCities from 'Components/profile/profile-details/addresses/country_MY.json'
import moment from 'moment';
const response = (data: any) => {
    // gender and ID type and number will be handled by backend
    // date we will send in YYYY-MM-DD format, then BE will format to the same also before sending to CMS API
    return omitBy({
        _id: data.profileID,
        fullName: !isEmpty(data.fullName)?data.fullName : undefined,
        dob: !isEmpty(data.dob)? moment(data.dob).format('YYYY-MM-DD') : undefined,
        primaryEmail: !isEmpty(data.primaryEmail)? (data.primaryEmail as string).toLowerCase(): undefined,
        gender: !isEmpty(data.gender)?data.gender: undefined,
        primaryPhone: data.primaryPhone.number?{
            type: 'MOBILE',
            countryCode: data.primaryPhone.dialCode,
            number: data.primaryPhone.number,
            fullNumber: `${data.primaryPhone.dialCode}${data.primaryPhone.number}`
        } : undefined,
        addresses: !isEmpty(data.addresses)?data.addresses.map((address) => {
            return omitBy({
                type: address.type,
                street1: address.street1,
                street2: address.street2? address.street2: undefined,
                city: address.city,
                cityCode:find(find(statesCities.STATES, (element) => address.state===element.NAME)?.CITIES, 
                            (element)=> element.NAME === address.city)?.CODE,
                state: address.state,
                stateCode: find(statesCities.STATES, (element) => address.state===element.NAME)?.CODE,
                postcode: address.postcode,
                country: address.country
            }, (value)=> isUndefined(value))
        }): [],
        primaryAddress: data.primaryAddress.street1? omitBy({
            type: data.primaryAddress.type,
            street1: data.primaryAddress.street1,
            street2: data.primaryAddress.street2 || '', // * set unwanted property to '' so that Arango will not simply merge with old data
            city: data.primaryAddress.city,
            cityCode: find(find(statesCities.STATES, (element) => data.primaryAddress.state===element.NAME)?.CITIES, 
                        (element)=> element.NAME === data.primaryAddress.city)?.CODE,
            state: data.primaryAddress.state,
            stateCode:  find(statesCities.STATES, (element) => data.primaryAddress.state===element.NAME)?.CODE,
            postcode: data.primaryAddress.postcode,
            country: data.primaryAddress.country
        },  (value) => isUndefined(value)): undefined,
        image: data.image? data.image: undefined,
        image_file: data.image_file? data.image_file: undefined,
        logoBase64String: !isEmpty(data.logoBase64String)? data.logoBase64String: undefined,
        identification: data.identificationNumber? {
            type: data.identificationType,
            no: data.identificationNumber
        } : undefined,
    }, (value)=> isUndefined(value))
}

export default response;